import { Inject, Injectable } from '@angular/core';

import { IntlService } from '@frontend/vanilla/core';
import { Observable, of } from 'rxjs';

import { IBetslipMessages } from '../../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../base/services/betslip-messages-provider.service';
import { formatObject } from '../../../../../base/utils/format-object';
import { BetslipError } from '../../../errors/betslip-error';
import { OpenDateNotReachedPreCheckError } from '../../../errors/pre-check/open-date-not-reached-pre-check-error';
import { MessageFormatter } from './message-formatter';

@Injectable()
export class OpenDateMessageFormatter extends MessageFormatter<OpenDateNotReachedPreCheckError> {
    private messages: IBetslipMessages;
    constructor(
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
        private intlService: IntlService,
    ) {
        super();
        this.messages = messageProvider.getMessages();
    }

    format(error: OpenDateNotReachedPreCheckError): Observable<string> {
        return of(
            formatObject(this.messages.errors.openDateNotReached, {
                date: this.intlService.formatDate(error.openDate, 'short'),
            }),
        );
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof OpenDateNotReachedPreCheckError;
    }
}
